import React from 'react';
import { useTranslation } from 'react-i18next';

import Layout from '../../Layout/Layout';
import WallTabs from './components/WallTabs';
import LocationsManager from '../../Locations/LocationsManager';

/**
 * Locations (branches) page — now a thin wrapper around the shared LocationsManager
 * (also embedded in the Schedule page's Locations tab). Restaurant context, so wall
 * assignment is enabled.
 */
export default function VideoWallLocations() {
  const { t } = useTranslation();
  return (
    <Layout>
      <WallTabs />
      <div className="mb-3">
        <h2 className="mb-1" style={{ color: 'var(--pp-text-primary)', fontWeight: 700 }}>
          <i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--pp-primary)' }} />
          {t('video_wall.locations.title')}
        </h2>
      </div>
      <LocationsManager showWalls />
    </Layout>
  );
}
